import React from 'react';
import { ClipLoader } from 'react-spinners';


class SpinnerComponent extends React.Component {
    state = {
        loading: true
    };
	render() {
		return (
			<div className='sweet-loading'>
				<ClipLoader
					className="clip-loader"
					sizeUnit={"px"}
					size={this.props.size?this.props.size:60}
					color={this.props.color?this.props.color:'#00CA95'}
					loading={this.state.loading}
				/>
			</div> 
		)
	}
}

export default SpinnerComponent;